const DEBOUNCE_TIME = 2000;

export default DEBOUNCE_TIME;
